<div class="pickup-space-door-indicator">
  <span class="pickup-space-door-indicator__label">{{ label | translate }}</span>
  <ng-container *ngIf="image; else spaceDoorIcon">
    <img [src]="image" alt="Space indicator" class="pickup-space-door-indicator__img" />
  </ng-container>
  <ng-template #spaceDoorIcon>
    <span
      *ngIf="color"
      class="pickup-space-door-indicator__icon pickup-space-door-indicator__icon--colored"
      [class.pickup-space-door-indicator__icon--blink]="mode === Illumination.BLINK"
    >
      <frodo-space-open-door-icon [color]="color"></frodo-space-open-door-icon>
    </span>
  </ng-template>
</div>
